import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import { contactModalActions } from './actions';

const initState = Map({
  visible: false,
});

export default function contactModalReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case contactModalActions.SHOW_CONTACT_MODAL:
      return state.set('visible', action.payload);
    default:
      return state;
  }
}
